import * as yup from 'yup';

export const initialValues = {
    excel: '',
    word: '',
    powerpoint: '',
    logicProgramming: '',
    logicProgrammingDescription: [],
    logicProgrammingDescriptionOther: '',
    english: '',
    spanish: '',
    courses: '',
}

const schema = 
yup.object().shape({
    excel: yup.string(),
    word: yup.string(),
    powerpoint: yup.string(),
    logicProgramming: yup.string(),
    logicProgrammingDescription: yup.array().of(yup.string()),
    logicProgrammingDescriptionOther: yup.string(),
    english: yup.string(),
    spanish: yup.string(),
    courses: yup.string(),
})

export default schema;